module.exports = __webpack_public_path__ + "img/main-reserve.0cbb5945.jpg";